<template>
  <div>
    <a-row>
      <a-col :span="8">
        <a-descriptions :column="1" class="simiot-descriptions">
          <a-descriptions-item label="入库批次">{{ batchOperationRecordInfo.operation_no }}</a-descriptions-item>
          <a-descriptions-item label="入库时间">{{ batchOperationRecordInfo.created_at }}</a-descriptions-item>
          <a-descriptions-item label="入库人">{{ batchOperationRecordInfo.operator_name }}</a-descriptions-item>
          <a-descriptions-item label="入库总数">{{ batchOperationRecordInfo.operation_count }}</a-descriptions-item>
          <a-descriptions-item label="入库成功数">{{ batchOperationRecordInfo.success_count }}</a-descriptions-item>
          <a-descriptions-item label="入库失败数">{{ batchOperationRecordInfo.failure_count }}</a-descriptions-item>
        </a-descriptions>
      </a-col>
      <a-col :span="8">
        <a-descriptions :column="1" class="simiot-descriptions">
          <a-descriptions-item label="生产日期">{{ batchOperationRecordInfo.production_date }}</a-descriptions-item>
          <a-descriptions-item label="生产批次">{{ batchOperationRecordInfo.production_batch }}</a-descriptions-item>
          <a-descriptions-item label="库房位置">{{ batchOperationRecordInfo.warehouse_location_name }}</a-descriptions-item>
          <a-descriptions-item label="eSIM供应商">{{ batchOperationRecordInfo.esim_supplier_name }}</a-descriptions-item>
          <a-descriptions-item label="SGP规范">{{ batchOperationRecordInfo.sgp_spec_names }}</a-descriptions-item>
          <a-descriptions-item label="LPA/IPA">{{ batchOperationRecordInfo.lpa_ipa_name }}</a-descriptions-item>
          <a-descriptions-item label="eIM平台">{{ batchOperationRecordInfo.eim_platform_name }}</a-descriptions-item>
          <a-descriptions-item label="卡片材质">{{ batchOperationRecordInfo.card_type_name }}</a-descriptions-item>
          <a-descriptions-item label="卡片尺寸">{{ batchOperationRecordInfo.card_shape_name }}</a-descriptions-item>
        </a-descriptions>
      </a-col>
      <a-col :span="8">
        <a-descriptions :column="1" class="simiot-descriptions">
          <a-descriptions-item label="是否有预制号">{{ boolText(batchOperationRecordInfo.has_preconfigured_number) }}</a-descriptions-item>
          <a-descriptions-item label="预制号是否用作Fallback">{{ boolText(batchOperationRecordInfo.is_preconfigured_number_fallback) }}</a-descriptions-item>
          <a-descriptions-item label="是否预制默认SM-DP+">{{ boolText(batchOperationRecordInfo.has_preconfigured_default_smdp) }}</a-descriptions-item>
          <a-descriptions-item label="SM-DP+地址">{{ batchOperationRecordInfo.smdp_address }}</a-descriptions-item>
          <a-descriptions-item label="是否预制根SM-DS">{{ boolText(batchOperationRecordInfo.has_preconfigured_root_smds) }}</a-descriptions-item>
          <a-descriptions-item label="SM-DS地址">{{ batchOperationRecordInfo.smds_address }}</a-descriptions-item>
          <a-descriptions-item label="制卡费">{{ batchOperationRecordInfo.card_fee }}</a-descriptions-item>
          <a-descriptions-item label="总制卡费">{{ batchOperationRecordInfo.total_card_fee }}</a-descriptions-item>
          <a-descriptions-item label="重跑次数">{{ batchOperationRecordInfo.run_times }}</a-descriptions-item>
          <a-descriptions-item label="备注">
            <span class="batch-operation-record-info">{{ batchOperationRecordInfo.remark }}</span>
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
    </a-row>
    <a-row>
      <a-col>
        <span>注：执行批量 eSIM 入库时，单个失败不影响其他 EID 入库，但批次结果可能为失败。</span>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: 'BatchOperationRecordEsimsImportInfo',
  props: {
    batchOperationRecordInfo: { type: Object, required: true }
  },
  methods: {
    boolText(val) {
      return val ? '是' : '否'
    }
  }
}
</script>
